import Forgot from './Forgot.vue'
export default {
    path:'forgot-password', component: Forgot
}